import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerComponent } from 'src/app/view/shared/loading-spinner/loading-spinner.component';
import { BannerComponent } from 'src/app/view/shared/banner/banner.component';
import { LazyloadDirective } from 'src/app/directives/lazyload/lazyload.directive';
import { ButtonComponent } from 'src/app/view/shared/button/button.component';



@NgModule({
  declarations: [
    LoadingSpinnerComponent,
    BannerComponent,
    LazyloadDirective,
    ButtonComponent
  ],
  imports: [
    CommonModule
  ],
  exports:[
    LoadingSpinnerComponent,
    BannerComponent,
    LazyloadDirective,
    ButtonComponent
  ]
})
export class SharedModule { }
